const _ = require('lodash');

/**
 * Card list controller
 * @param {} scope
 * @returns {}
 */
function CardListCtrl(scope, $sce, $q, $state, breakpointsService, cardDetailService, cardSizeService, cardSortService, settingsService) {
    /**
     * Called by a card list provider implementation as a child directive.
     * Configures the card list with the given options.
     * @param {Object} options - Options to configure the card list.
     * @param {Function} options.getCards - returns a promise for a list of cards.
     *  options.
     * @param {Function} [options.getTitle] - returns a string used as the card list title.
     * @param {Object} [options.topRightButton] - contains options for the top right button.
     * @param {Function} options.topRightButton.getText - returns a string and will be bound to
     *  the button label.
     * @param {Function} options.topRightButton.onClick - called whenever the top right button
     *  is clicked.
     * @param {Object} [options.topLeftLabel] - [DEPRECATED] contains options for the top left
     *  label.
     * @param {Function} options.topLeftLabel.getText - returns a label which will be bound to
     *  the top left label.
     * @param {string} [options.zeroCardsTemplate] - will be compiled and used as the template
     *  if `getCards()` returns an empty list.
     * @param {Function} [options.onFinishRender] - will be called once the first page of cards
     *  has rendered.
     * @param {boolean} [options.smallerProductStampsEnabled] - indicates if smaller product
     *  stamps are enabled.
     * @param {boolean} [options.shouldGetInspirationCards=true] - indicates if this card list
     *  should fetch inspiration cards for the current URL and splice them into the list.
     * @param {boolean} [options.disablePaging=false] - indicates if the card list should be
     *  updated when the user logs in.
     * @param {boolean} [options.updateCardsOnLogin=true] - indicates if the card list should
     *  be updated when the user logs in.
     * @param {boolean} [options.enableHeader=true] - indicates if the card list header
     *  (including sort options) is displayed. This is useful if an `h2` doesn't make sense
     *  whenever you are using the card list.
     * @param {boolean} [options.enableDetail=true] - indicates if the cards in the list should
     *  be able to open their detail cards.
     * @param {boolean} [options.resetScroll=true] - indicates if the page scroll position
     *  should be reset by this card list.
     */
    this.setOptions = function (options) {
        scope.getCards = options.getCards;
        scope.getTitle = options.getTitle || _.noop;

        scope.zeroCardsTemplate = options.zeroCardsTemplate;
        scope.onFinishRender = options.onFinishRender;

        scope.shouldGetInspirationCards = options.shouldGetInspirationCards !== false;
        scope.disablePaging = options.disablePaging;
        scope.updateCardsOnLogin = options.updateCardsOnLogin === undefined || options.updateCardsOnLogin;
        scope.enableHeader = options.enableHeader === undefined || options.enableHeader;
        scope.enableDetail = options.enableDetail === undefined || options.enableDetail;
        scope.resetScroll = options.resetScroll === undefined || options.resetScroll;

        scope.topRightButton = options.topRightButton;
        scope.topLeftLabel = options.topLeftLabel;
        scope.topLeftLabelContent = function () {
            return $sce.trustAsHtml(options.topLeftLabel.getText());
        };

        settingsService.getSettingValue('OneSite', 'SmallerProductStampsEnabled').then(function (enabled) {
            scope.smallerProductStampsEnabled = enabled && options.smallerProductStampsEnabled && !breakpointsService.isInSmallFormat;
            scope.stampSize = cardSizeService.getSize(scope.smallerProductStampsEnabled);
        });

        scope.initDetailFunctionality(scope.enableDetail);
    };

    scope.initDetailFunctionality = function (isEnabled) {
        if (isEnabled) {
            scope.showStaticProductDetails = !!$state.params.productId;
            scope.showStaticRecipeDetails = !!$state.params.recipeId && !scope.showStaticProductDetails;
            scope.staticRecipeId = $state.params.recipeId;

            // watch trigger when someone clicks on a different card detail
            scope.$watch(function () {
                return cardDetailService.cardId;
            }, function () {
                scope.updateDetail();
            });

            scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                // close the card details if they moved from a state with a card id to a state without a card id.
                if (cardDetailService.containsCardId(fromParams) && !cardDetailService.containsCardId(toParams)) {
                    scope.closeStaticDetails();
                }
            });
        }
    };

    /*
    * Update zerocard template manually
    */
    this.updateZeroCardTemplate = function (template) {
        scope.zeroCardsTemplate = template;
    };

    /**
     * Call to manually update the card list from the card source.
     */
    this.update = function () {
        return scope.update(true);
    };

    this.updateTitle = function () {
        scope.title = scope.getTitle();
    };

    this.resetCards = function () {
        scope.resetCards();
    };
}

module.exports = CardListCtrl;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/card-list-controller.js
 **/